import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PaymentMethodsBaseComponent} from "./payment-methods-base.component";
import {GameService} from "../../services/game.service";
import {AgGridAngular} from "ag-grid-angular";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ContainerComponent, RowComponent, ColComponent} from "@coreui/angular";
import {MatOption, MatSelect} from "@angular/material/select";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";

/**
 * Single scope-aware payment-methods page, replacing the former cross-game / game-admin pair.
 * Scope comes from route data (`isCrossGame`): global scope shows the game picker, game scope uses
 * the active game. Neither scope loads anything until the admin searches — see
 * PaymentMethodsBaseComponent.searchPaymentMethods.
 */
@Component({
  selector: 'app-payment-methods',
  standalone: true,
  imports: [
    AgGridAngular,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    ReactiveFormsModule,
    FormsModule,
    ContainerComponent,
    RowComponent,
    ColComponent,
    MatSelect,
    MatOption,
    ChooseYourGameComponent
  ],
  templateUrl: './payment-methods.component.html',
  styleUrl: './payment-methods.component.scss'
})
export class PaymentMethodsComponent extends PaymentMethodsBaseComponent {
  private route = inject(ActivatedRoute);
  private gameService: GameService = inject(GameService);

  constructor() {
    super();
    this.isCrossGame = this.route.snapshot.data['isCrossGame'] === true;

    if (!this.isCrossGame) {
      // Search-first: the game is known, but nothing is fetched until the admin supplies a filter
      // and states a reason. Loading the game's payment methods on arrival is what #1507 removed.
      this.game = this.gameService.activeGame();
    }
  }
}
